import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const getCardImageUploadSignedUrl = async (userId, cardId, fileType) => {
  const apiPath = `cards/user/${userId}/card/${cardId}/image-upload-signed-url`;

  const data = {
    contentType: fileType,
  };

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    body: JSON.stringify(data),
    data: data,
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
